/* eslint-disable no-await-in-loop */

/* eslint-disable no-const-assign */

/* eslint-disable no-plusplus */

/* eslint-disable consistent-return */

/* eslint-disable no-return-assign */
import '@fontsource/poppins';
import { Icon } from '@iconify/react';
import axios from 'axios';
import dayjs from 'dayjs';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { EditButton, ViewButton } from '@src/components/buttons';
import ButtonAction from '@src/components/buttons/action.button';
import Container from '@src/components/commons/containerPage.common';
import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

function DateRangePicker({ startDate, endDate, onStartChange, onEndChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid #ccc',
          borderRadius: 2,
          px: 1.5,
          py: 0.5,
          width: 'fit-content',
          backgroundColor: 'white',
          '& .MuiInputBase-root': {
            border: 'none !important',
            boxShadow: 'none !important',
            '&:before, &:after': {
              display: 'none',
            },
          },
        }}
      >
        <DatePicker
          reduceAnimations
          value={startDate ? dayjs(startDate) : null}
          onChange={onStartChange}
          format='DD-MM-YYYY'
          slotProps={{
            textField: {
              variant: 'standard',
              size: 'small',
              sx: {
                minWidth: 110,
                '& .MuiInputBase-input': {
                  padding: '4px 0',
                },
              },
              placeholder: 'from',
            },
          }}
        />

        <Typography sx={{ mx: 1 }}>–</Typography>

        <DatePicker
          reduceAnimations
          value={endDate ? dayjs(endDate) : null}
          onChange={onEndChange}
          format='DD-MM-YYYY'
          slotProps={{
            textField: {
              variant: 'standard',
              size: 'small',
              sx: {
                minWidth: 110,
                '& .MuiInputBase-input': {
                  padding: '4px 0',
                },
              },
              placeholder: 'to',
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default function CampaignManagement() {
  const { auth } = useAuth();
  const path = useLocation().pathname;
  const [campaign, setCampaign] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [deleteStatus, setDeleteStatus] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);

  const handleUpdateCampaign = (campaignId) => {
    navigate(`/update-campaign/${campaignId}`);
  };

  const handleViewCampaign = (campaignId) => {
    navigate(`/detail-campaign/${campaignId}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/admin/v3/messages/twilio/campaigns/${id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
            'My-Custom-Header': 'foobar',
          },
        },
      );

      if (response.status === 200) {
        console.log(response);
        setDeleteStatus('Delete successful');
        setShowDeleteSuccess(true);
      } else {
        console.error('Delete operation failed');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showDeleteConfirmationDialog = (id) => {
    setDeleteId(id);
    setShowDeleteConfirmation(true);
  };

  const handleConfirmationDialogClose = () => {
    setShowDeleteConfirmation(false);
  };

  const handleConfirmationDialogConfirm = () => {
    handleDelete(deleteId);
    setShowDeleteConfirmation(false);
  };

  const [startDate, setStartDate] = useState(null);

  const [endDate, setEndDate] = useState(null);
  const [searchName, setSearchName] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchSender, setSearchSender] = useState('');
  const [searchAudience, setSearchAudience] = useState('');

  const handleStartDate = (newValue) => {
    if (!newValue) {
      setStartDate(null);
      return;
    }

    if (typeof newValue === 'string') {
      setStartDate(newValue);
      return;
    }

    if (dayjs.isDayjs(newValue)) {
      setStartDate(newValue.format('YYYY-MM-DDTHH:mm'));
      return;
    }

    setStartDate(dayjs(newValue).format('YYYY-MM-DDTHH:mm'));
  };

  const handleEndDate = (newValue) => {
    if (!newValue) return setEndDate(null);
    setEndDate(
      dayjs.isDayjs(newValue) ? newValue.format('YYYY-MM-DDTHH:mm') : newValue,
    );
  };

  const [filteredCampaign, setFilteredCampaign] = useState();

  const fetchData = async (limit = 10) => {
    if (!auth?.idToken) return;

    setLoading(true);

    try {
      let allData = [];
      let currentPage = 1;
      let hasMore = true;
      let paginationData = {};

      while (hasMore) {
        const params = new URLSearchParams();
        params.append('page', currentPage);
        params.append('limit', limit);

        if (searchName) params.append('search', searchName);
        if (searchStatus) params.append('status', searchStatus);
        if (startDate) params.append('scheduledDateFrom', startDate);
        if (endDate) params.append('scheduledDateTo', endDate);

        const response = await axios.get(
          `${url}/admin/v3/messages/twilio/campaigns?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${auth.idToken}`,
            },
          },
        );

        const res = response.data?.response || {};
        const currentData = Array.isArray(res.data) ? res.data : [];
        const currentPagination = res.pagination || {};

        allData = [...allData, ...currentData];
        paginationData = currentPagination;

        if (currentPagination?.hasNextPage) {
          currentPage++;
        } else {
          hasMore = false;
        }
      }

      setCampaign(allData);
      setFilteredCampaign(allData);
      setPagination(paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let data = [...(campaign || [])];

    // filter by sender
    if (searchSender) {
      data = data.filter((c) =>
        c.sender?.sender_name
          ?.toLowerCase()
          .includes(searchSender.toLowerCase()),
      );
    }

    if (searchAudience) {
      data = data.filter((c) =>
        c.audienceSegment?.audi_segment_name
          ?.toLowerCase()
          .includes(searchAudience.toLowerCase()),
      );
    }

    setFilteredCampaign(data);
  }, [campaign, searchSender, searchAudience]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth.idToken,
    searchName,
    searchSender,
    searchStatus,
    searchAudience,
    startDate,
    endDate,
    deleteStatus,
  ]);

  const handleDuplicate = (campaignId) => {
    const sourceCampaign = campaign.find((c) => c.the_id === campaignId);

    if (!sourceCampaign) {
      toast.error('Campaign not found');
      return;
    }

    const formData = {
      account_the_id: sourceCampaign?.account_the_id,
      inbox_the_id: sourceCampaign?.inbox_the_id,
      sender_the_id: sourceCampaign?.sender_the_id,
      cmp_name: `${sourceCampaign?.cmp_name ?? ''} - Copy`,
      cmp_code: `${sourceCampaign?.cmp_code ?? ''}-copy`,
      cmp_description: sourceCampaign?.cmp_description,
      content_template_id: sourceCampaign?.content_template_id,
      content_template_definitions: {
        body: sourceCampaign?.content_template_definitions?.body,
      },
      content_template_variable: {
        meta: {
          variable_count:
            sourceCampaign?.content_template_variable?.variables?.length || 0,
        },
        variables: (
          sourceCampaign?.content_template_variable?.variables || []
        ).map((v, index) => ({
          idx: index + 1,
          name: (index + 1).toString(),
          label: v.label,
          value: v.value,
          idx_str: String(index + 1).padStart(3, '0'),
          var_code: `{{${index + 1}}}`,
          value_type: v.value_type || 'user_defined',
          default_value: v.default_value || 'user_input',
          example_value: v.example_value,
          value_ui_type: v.value_ui_type || 'text',
          value_is_editable:
            typeof v.value_is_editable === 'boolean'
              ? v.value_is_editable
              : true,
        })),
      },

      cmp_type: sourceCampaign?.cmp_type || 'whatsapp',
      cmp_status: 'draft',
      cmp_trigger_rules: null,
      cmp_audience: sourceCampaign?.cmp_audience,
      cmp_scheduled_at: sourceCampaign?.cmp_scheduled_at,
      cmp_trigger_only_during_business_hours:
        sourceCampaign?.cmp_trigger_only_during_business_hours ?? false,
      cmp_metadata: null,
      is_active: true,
    };

    axios
      .post(`${url}/admin/v3/messages/twilio/campaigns`, formData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        toast.success('Campaign duplicated successfully!', {
          position: 'top-center',
          autoClose: 2000,
        });
        fetchData();
        setCampaign((prev) => [...prev, response.data?.response?.data]);
      })
      .catch((error) => {
        toast.error(
          `${error.response?.data?.system?.message || 'An error occurred'}`,
          {
            position: 'top-center',
            autoClose: 2000,
          },
        );
      });
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // fetchData(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    fetchData(1, newLimit);
  };
  return (
    <Container pathUrl={path}>
      <div className='px-4'>
        <Box
          sx={{ width: '100%', height: '60px' }}
          className='flex w-[95%] justify-end'
        >
          <ButtonAction
            onNavigate={() => {
              navigate('/create-campaign');
            }}
            label='Create New Campaign'
          />
        </Box>

        <div className='flex justify-start'>
          <Box
            sx={{ width: '100%', height: 'auto' }}
            className='rounded-xl bg-white py-4 pl-5'
          >
            <Grid container spacing={2}>
              {/* Name */}
              <Grid item xs={12} sm={6} md={2}>
                <Typography className='font-poppins text-sm text-gray-400'>
                  Name
                </Typography>
                <TextField
                  fullWidth
                  variant='outlined'
                  size='small'
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': { borderRadius: 2 },
                  }}
                  value={searchName || ''}
                  onChange={(e) => setSearchName(e.target.value)}
                  placeholder='Search by name'
                />
              </Grid>

              {/* Sender */}
              <Grid item xs={12} sm={6} md={2}>
                <Typography className='font-poppins text-sm text-gray-400'>
                  Sender
                </Typography>
                <TextField
                  fullWidth
                  variant='outlined'
                  size='small'
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': { borderRadius: 2 },
                  }}
                  value={searchSender || ''}
                  onChange={(e) => setSearchSender(e.target.value)}
                  placeholder='Search by sender'
                />
              </Grid>

              {/* Audience */}
              <Grid item xs={12} sm={6} md={2}>
                <Typography className='font-poppins text-sm text-gray-400'>
                  Audience
                </Typography>
                <TextField
                  fullWidth
                  variant='outlined'
                  size='small'
                  sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': { borderRadius: 2 },
                  }}
                  value={searchAudience || ''}
                  onChange={(e) => setSearchAudience(e.target.value)}
                  placeholder='Search by audience'
                />
              </Grid>

              {/* Status */}
              <Grid item xs={12} sm={6} md={1.5}>
                <Typography className='font-poppins text-sm text-gray-400'>
                  Status
                </Typography>
                <Select
                  fullWidth
                  size='small'
                  displayEmpty
                  sx={{ mt: 1, borderRadius: 2 }}
                  MenuProps={{
                    disablePortal: true,
                    PaperProps: { style: { zIndex: 1302 } },
                  }}
                  value={searchStatus || ''}
                  onChange={(e) => setSearchStatus(e.target.value)}
                >
                  <MenuItem disabled value=''>
                    <em style={{ color: '#8C8C8C' }}>Select</em>
                  </MenuItem>
                  <MenuItem value=''>ALL</MenuItem>
                  <MenuItem value='draft'>Draft</MenuItem>
                  <MenuItem value='tested'>Tested</MenuItem>
                  <MenuItem value='published'>Published</MenuItem>
                  <MenuItem value='executed'>Executed</MenuItem>
                  <MenuItem value='scheduled'>Scheduled</MenuItem>
                  <MenuItem value='processed'>Processed</MenuItem>
                  <MenuItem value='cancelled'>Cancelled</MenuItem>
                </Select>
              </Grid>

              {/* Date + Clear */}
              <Grid item xs={12} sm={12} md={3}>
                <Typography className='font-poppins text-sm text-gray-400'>
                  Range Date
                </Typography>
                <div className='pt-2'>
                  <DateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onStartChange={handleStartDate}
                    onEndChange={handleEndDate}
                  />
                </div>
              </Grid>
              <div className='pt-11 pl-8'>
                <Button
                  variant='contained'
                  className='rounded-md bg-cyan-600 py-2 text-sm font-bold'
                  sx={{
                    width: '80px',
                    height: '38px',
                    textTransform: 'none',
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                  }}
                  onClick={() => {
                    setSearchName('');
                    setSearchSender('');
                    setSearchStatus('');
                    setSearchAudience('');
                    setStartDate(null);
                    setEndDate(null);
                    fetchData();
                  }}
                >
                  Clear
                </Button>
              </div>
            </Grid>
          </Box>
        </div>

        {loading ? (
          <div className='font-poppins py-6 px-8 text-gray-500'>Loading...</div>
        ) : (
          <span className='flex flex-col items-start pt-6'>
            <TableContainer
              className='rounded-xl'
              component={Paper}
              style={{
                width: '100%',
                paddingBottom: '12px',
                backgroundColor: '#ffffff',
                borderColor: 'ffffff',
              }}
            >
              <Table
                sx={{
                  minWidth: 350,
                  backgroundColor: '#ffffff',
                  borderColor: 'ffffff',
                }}
                aria-label='simple table'
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ width: 370, pl: 2 }}
                      className='text-xs font-bold text-gray-500'
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{ width: 150, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Code
                    </TableCell>
                    <TableCell
                      sx={{ width: 120, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Sender
                    </TableCell>
                    <TableCell
                      sx={{ width: 200, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Audience
                    </TableCell>
                    <TableCell
                      sx={{ width: 200, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Schedule
                    </TableCell>
                    <TableCell
                      sx={{ width: 50, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{ width: 80, p: 1 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Is Active
                    </TableCell>
                    <TableCell
                      sx={{ width: 80, p: 1, pr: 0 }}
                      className='text-center text-xs font-bold text-gray-500'
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.isArray(filteredCampaign) &&
                  filteredCampaign.length > 0 ? (
                    filteredCampaign
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row) => (
                        <TableRow
                          key={row?._id}
                          hover
                          tabIndex={-1}
                          sx={{
                            '&:hover': {
                              backgroundColor: '#F9FAFB',
                            },
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <TableCell
                            sx={{
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'normal',
                              maxWidth: 50,
                              py: 1.5,
                            }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.cmp_name || '-'}
                          </TableCell>

                          <TableCell
                            sx={{
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'normal',
                              maxWidth: 50,
                              py: 1.5,
                            }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row.cmp_code}
                          </TableCell>

                          <TableCell
                            sx={{ py: 1.5 }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.sender?.sender_name || '-'}
                          </TableCell>

                          <TableCell
                            sx={{
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'normal',
                              maxWidth: 50,
                              py: 1.5,
                            }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.audienceSegment?.audi_segment_name || '-'}
                          </TableCell>

                          <TableCell
                            sx={{ py: 1.5 }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.cmp_scheduled_at
                              ? dayjs(row.cmp_scheduled_at)
                                  .tz('Asia/Singapore')
                                  .format('DD MMM YYYY, h:mm A')
                              : '-'}
                          </TableCell>

                          <TableCell sx={{ py: 1.5 }}>
                            <Box
                              sx={{
                                backgroundColor:
                                  row?.cmp_status === 'executed' ||
                                  row?.cmp_status === 'scheduled' ||
                                  row?.cmp_status === 'processed'
                                    ? '#DCFCE7'
                                    : row?.cmp_status === 'tested' ||
                                      row?.cmp_status === 'testing' ||
                                      row?.cmp_status === 'published'
                                    ? '#E0F2FE'
                                    : '#FEF3C7',
                                color:
                                  row?.cmp_status === 'executed' ||
                                  row?.cmp_status === 'scheduled' ||
                                  row?.cmp_status === 'processed'
                                    ? '#15803D'
                                    : row?.cmp_status === 'tested' ||
                                      row?.cmp_status === 'testing' ||
                                      row?.cmp_status === 'published'
                                    ? '#0369A1'
                                    : '#92400E',
                                borderRadius: '12px',
                                px: 1.5,
                                py: 0.5,
                                display: 'inline-block',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                textTransform: 'capitalize',
                                width: '85px',
                                textAlign: 'center',
                              }}
                            >
                              {row?.cmp_status}
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{ py: 1.5 }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.is_active ? 'true' : 'false'}
                          </TableCell>

                          <TableCell sx={{ py: 1.5 }}>
                            <Box display='flex' alignItems='center' gap={1.2}>
                              <ViewButton
                                onClick={() => handleViewCampaign(row?.the_id)}
                              />
                              <EditButton
                                onClick={() =>
                                  handleUpdateCampaign(row?.the_id)
                                }
                                disabled={!(row?.cmp_status === 'draft')}
                              />
                              &nbsp;
                              <Tooltip title='Duplicate campaign'>
                                <Icon
                                  icon='lucide:copy'
                                  color='#0284C7'
                                  width='22'
                                  style={{
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1.2)')
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1)')
                                  }
                                  onClick={() => handleDuplicate(row?.the_id)}
                                />
                              </Tooltip>
                              <Tooltip title='Delete campaign'>
                                <Icon
                                  icon='lucide:trash-2'
                                  color='#EF4444'
                                  width='22'
                                  style={{
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1.2)')
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1)')
                                  }
                                  onClick={() =>
                                    showDeleteConfirmationDialog(row?.the_id)
                                  }
                                />
                              </Tooltip>
                            </Box>
                          </TableCell>
                          {showDeleteConfirmation && (
                            <Dialog
                              open={showDeleteConfirmation}
                              onClose={handleConfirmationDialogClose}
                            >
                              <DialogTitle sx={{ fontWeight: 600 }}>
                                Confirm Delete
                              </DialogTitle>
                              <DialogContent>
                                <DialogContentText>
                                  Are you sure you want to delete this campaign?
                                </DialogContentText>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  onClick={handleConfirmationDialogClose}
                                  color='primary'
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={handleConfirmationDialogConfirm}
                                  color='error'
                                >
                                  Delete
                                </Button>
                              </DialogActions>
                            </Dialog>
                          )}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align='center'>
                        <Typography className='font-poppins py-6 italic text-gray-400'>
                          No campaign listed
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Box
                className='flex justify-end py-3'
                sx={{ width: '100%', fontFamily: 'Poppins' }}
              >
                <TablePagination
                  component='div'
                  count={pagination?.totalItems || 0}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                />
              </Box>
            </TableContainer>
          </span>
        )}
      </div>
      <br />
      <br />
      <br />

      {showDeleteSuccess && (
        <Dialog
          open={showDeleteSuccess}
          onClose={() => setShowDeleteSuccess(false)}
        >
          <DialogTitle>Delete Successful</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The campaign has been deleted successfully.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDeleteSuccess(false)} color='primary'>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
}
